const Support = () => {
  return (
    <div className="stockwiz-landing__container__support">
      <a
        className="d-flex align-items-center gap-2 "
        href="tel:+917850934748"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/b2b/stockwiz/svg/phoneicon.svg" alt="phoneicon" />
        +91-7850934748
      </a>
      <a
        className="d-flex align-items-center gap-2 "
        href="https://api.whatsapp.com/send?phone=916350670245&text=I%20need%20assistance%20with%20StrykeX%2C%20please%20connect%20me%20to%20the%20support%20team"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/b2b/stockwiz/svg/whatsappicon.svg" alt="whatsappicon" />
        +91-8000030231
      </a>
      <a
        className="d-flex align-items-center gap-2 "
        href="mailto:help@stockwiz.in"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/b2b/stockwiz/svg/emailicon.svg" alt="emailicon" />
        help@stockwiz.in
      </a>
    </div>
  );
};

export default Support;
